export default function LocationController(
    $scope,
    $rootScope,
    $filter,
    searchResultFactory,
    searchBarFactory,
    houseService,
    searchService,
    Basket,
    siteService,
    $timeout,
    // searchFilterFactory, // TO DO ::: check func ???
    moment,
    searchUrl,
    siteTitleFactory,
    DummyApi,
    Scroll
) {
    searchUrl.init().then((res) => {
        console.log(res);
        $scope.activity = res.activity;
        $scope.location = res.location;
        $scope.date = res.date;
    });

    $scope.selectedBookings = Basket.currentBookings;

    $scope.searchBarOnly = true;

    $scope.periodsWithinSelectedTime =
        searchResultFactory.periodsWithinSelectedTime;
    /**************************************
     * NO RESULTS
     **************************************/

    $scope.getNextAvailableResults = function () {
        houseService.getSearchGroupedNextResult().then(function (houses) {
            if (houses.GroupingInfos.length || houses.ParentLanes.length) {
                // Convert API date
                var nextAvailableDate = $filter("date")(
                    houses.NextAvailableDate,
                    "dd-MM-yyyy"
                );

                // Set neccesary date vars
                houseService.searchFilter.startDate = nextAvailableDate;

                houseService.searchFilter.startTime = angular.copy(
                    houseService.calenderFilter.startTime()
                ); // update the API param

                houseService.calenderFilter.selectedDate = nextAvailableDate;

                $scope.oSearchCalender = searchBarFactory.get_oSearchCalender();
                $scope.oSearchCalender.userSelected.date = nextAvailableDate; // will bind to (houseService.searchFilter.startDate) when clicking search in search Bar

                $rootScope.$broadcast("update-date-broadcast", {
                    date: nextAvailableDate,
                    tooltip: true,
                });

                // Format startDate
                houseService.searchFilter.startDateDayOfWeek = moment(
                    houseService.searchFilter.startDate,
                    "DD-MM-YYYY"
                ).toDate();

                $scope.$broadcast("next-results-update-broadcast", houses);

                searchBarFactory.searchBroadcast();
            } else {
                // NO RESULT IN RANGE
                $scope.searchResults = houseService.searchResults = houses;
            }
        });
    };

    /**************************************
     * BROADCAST RECIEVER
     **************************************/
    // When user clicks Search in searchbar -> Recieve Broadcast from Searchbar.js -> houseService
    var searchNowEventListener = $scope.$on(
        "search-now-broadcast",
        function () {
            $scope.searchFilter = houseService.searchFilter;

            search();
        }
    );
    $scope.$on("$destroy", searchNowEventListener);

    var UITooltipEventListener = $rootScope.$on(
        "show-UI-Tooltip-preventWideSearch",
        function () {
            // avail param : event
            $scope.searchBarOnly = true;
        }
    );
    $scope.$on("$destroy", UITooltipEventListener);

    /**************************************
     * On Load
     **************************************/

    // Set filter
    // ONLY USED WHEN NO RESULTS
    $scope.searchFilter = houseService.searchFilter;

    // Show searchresult with selected root/parent
    $timeout(function () {
        //var $container = $("#isotopeContainer");
        $scope.$emit("iso-option", { filter: ".-1" });
    });

    /*******************************
     *  Scroll Functions
     *******************************/

    // When user clicks Search in searchbar -> Recieve Broadcast from Searchbar.js -> houseService
    var scrollToEventListener = $scope.$on(
        "scroll-to-elem-broadcast",
        function (broadcastObj, elemId, offset) {
            $scope.ScrollToResults(elemId, offset);
        }
    );
    $scope.$on("$destroy", scrollToEventListener);

    $scope.ScrollToResults = function (elemID, offset) {
        $timeout(() => {
            Scroll.to(elemID, offset);
        });
    };

    $scope.shouldPageScrollToResults = function () {
        if (siteService.scrollToSearchResults) {
            var offset = siteService.headerHeight + 15;
            $scope.ScrollToResults("title-focus", offset);

            siteService.scrollToSearchResults = false;
        }
    };

    /****************************************
     *
     * SEARCH
     *
     */

    function search() {
        if (
            houseService.searchFilter.houseCategory.CategoryID == 0 &&
            houseService.searchFilter.houseType.ID == -1
        ) {
            $timeout(function () {
                $rootScope.$broadcast("show-UI-Tooltip-preventWideSearch");
            }, 500);

            return false;
        }

        // Format startDate2
        houseService.searchFilter.startDateDayOfWeek = moment(
            houseService.searchFilter.startDate,
            "DD-MM-YYYY"
        ).toDate();

        if (DummyApi.isEnabled()) {
            let items = DummyApi.getSearchByLocation(); // getSearchResult

            $scope.searchBarOnly = false;

            $scope.newSearchResultFromApi(items);
        } else {
            searchService.getByLocation().then(function (items) {
                $scope.searchBarOnly = false;
                $scope.newSearchResultFromApi(items);
            });
        }
    }

    /**
     * Handle search response
     */
    $scope.newSearchResultFromApi = function (houses) {
        siteTitleFactory.setForSearch(houses);

        $scope.activity = houseService.searchFilter.houseCategory;
        $scope.location = houseService.searchFilter.houseType;

        $scope.searchResults = houseService.searchResults = houses;

        // Viewtype defines the search view type // activities, locations or periods
        houseService.viewType = houses.ViewType;

        // Update var to deliver selected time to search-filter
        houseService.searchFilter.selectedTimeObj =
            searchBarFactory.selectedTimeObj;

        // tell everyone that new search-results has arrived
        $rootScope.$broadcast("search-updated-broadcast", houses);

        // isotope
        houseService.searchFilter.selectedFilter = -1; // reset filter to all

        // pagescroll handler
        $scope.shouldPageScrollToResults();
    };

    /**
     * TOOLTIP - Repeatable Pattern Detected!
     */
    $scope.showRepeatableBookingTooltip = false;

    $scope.dismissRepeatableBookingTooltip = function () {
        $scope.showRepeatableBookingTooltip = false;
    };
}
